import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

import 'assets/styles/index.css';
import 'assets/styles/bootstrap.scss';
import 'assets/styles/fonts.scss';
import ScrollToTop from 'components/ScrollToTop';
import RegisterProvider from 'context/RegisterProvider';
import CompanyValidationProvider from 'context/CompanyValidationProvider';
import Index from 'routes';
import CompanySelection from './routes/company-selection';
import Completed from './routes/completed';
import CompanyCheck from './routes/company-check';
import NotFound from 'routes/not-found';
import Register from 'routes/register';
import Test from 'routes/test';
import Validation from 'routes/validation';
import AwaitingValidation from 'routes/awaiting-validation';

import 'utils/axiosHeaders';

import App from './App';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <RegisterProvider>
        <CompanyValidationProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path='/' element={<App />}>
                <Route index element={<Index />} />
                <Route path='/:locale/' element={<Register />} />
                <Route path='/:locale/awaiting-validation' element={<AwaitingValidation />} />
                <Route path='/:locale/company/:token/:code' element={<CompanyCheck />} />
                <Route path='/:locale/validation/:activityId/:userId/:code' element={<CompanySelection />} />
                <Route path='/:locale/validation/:activityId/:code' element={<Validation />} />
                <Route path='/:locale/validation/:code' element={<Validation />} />
                <Route path='/:locale/validation-user/:userId/:activityId/:code' element={<CompanySelection />} />
                <Route path='/:locale/validation-user/:userId/:code' element={<CompanySelection />} />
                <Route path='/:locale/register-finished' element={<Completed />} />
                <Route path='/:locale/test' element={<Test />} />
                <Route path='*' element={<NotFound />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </CompanyValidationProvider>
      </RegisterProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
